import { Flex,Table } from 'antd'
import React from 'react'
import classes from './income.module.css'
import Copy from '../../cpn/Copy';
import StateTag from '../../cpn/StateTag';
import IncomeCheck from './IncomeCheck';
import IncomeEditReportEdit from './IncomeEditReportEdit';
import IncomeAddReportEdit from './IncomeAddReportEdit';
function IncomeListReport(props) {
     // 格式化金额显示
     const formatCurrency = (text) => (
         <span>
             ￥{Number(text).toLocaleString('zh-CN', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
             })}
         </span>
     );

     // 基础列定义
     const columns = [
        {  
            dataIndex: 'index', 
            width: 42, 
            key: '序号' ,
            render: (text, record, index) => index + 1,
            title: '序号',
        },       
      
        { 
            title: '收款客户', 
            dataIndex: 'ddsr_kh_name', 
            width: 200, 
            key: 'ddsr_kh_name' ,
            render: (text, record) => {
                if(record.ddsr_state === '1'){
                    return  <IncomeEditReportEdit
                                ddsr_id={record.ddsr_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                ddsr_bzd_id={record.ddsr_bzd_id}
                                ddsr_bzd_name={record.ddsr_bzd_name}
                                ddsr_price={record.ddsr_price}
                                ddsr_content={record.ddsr_content}
                                ddsr_date={record.ddsr_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                ddsr_type_id={record.ddsr_type_id}
                                ddsr_type_name={record.ddsr_type_name}
                                ddsr_kh_id={record.ddsr_kh_id}
                                ddsr_kh_name={record.ddsr_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                ddsr_num={record.ddsr_num}
                                ddsr_amount={record.ddsr_amount}
                                ddsr_uid={record.ddsr_uid}
                                ddsr_state={record.ddsr_state}
                                ddsr_image_name={record.ddsr_image_name}
                                ddsr_image_file={record.ddsr_image_file}
                                dsbzd_id={props.dsbzd_id}
                                ddsr_name={record.ddsr_name}
                                ddsr_bm_id={record.ddsr_bm_id}
                                ddsr_bm_name={record.ddsr_bm_name}
                                ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                ddsr_ctime={record.ddsr_ctime}
                            />
                }else{
                    return  <IncomeCheck
                                type='button'
                                ddsr_id={record.ddsr_id}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                ddsr_bzd_id={record.ddsr_bzd_id}
                                ddsr_bzd_name={record.ddsr_bzd_name}
                                ddsr_price={record.ddsr_price}
                                ddsr_content={record.ddsr_content}
                                ddsr_date={record.ddsr_date}
                                dsbzd_date={props.dsbzd_date}
                                dsbzd_date_end={props.dsbzd_date_end}
                                dsbzd_name={props.dsbzd_name}
                                ddsr_type_id={record.ddsr_type_id}
                                ddsr_type_name={record.ddsr_type_name}
                                ddsr_kh_id={record.ddsr_kh_id}
                                ddsr_kh_name={record.ddsr_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                ddsr_num={record.ddsr_num}
                                ddsr_amount={record.ddsr_amount}
                                ddsr_uid={record.ddsr_uid}
                                ddsr_state={record.ddsr_state}
                                ddsr_image_name={record.ddsr_image_name}
                                ddsr_image_file={record.ddsr_image_file}
                                dsbzd_id={props.dsbzd_id}
                                ddsr_name={record.ddsr_name}
                                ddsr_bm_id={record.ddsr_bm_id}
                                ddsr_bm_name={record.ddsr_bm_name}
                                ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                ddsr_ctime={record.ddsr_ctime}
                            />
                }
            }
        },      
        { 
             title: '收款金额', 
             dataIndex: 'ddsr_amount', 
             width: 200, 
             key: 'ddsr_amount',
             render: (text) => <span style={{ color: 'red' }}>{formatCurrency(text)}</span>
        },
        { 
            title: '收款事由', 
            dataIndex: 'ddsr_name', 
            key: 'ddsr_name',
            render: (text, record) => <Copy title={text}/>
        },                                  
        {
            title: '状态',
            dataIndex: 'ddsr_state',
            width: 80,
            key: 'ddsr_state',
            render: (text) => <StateTag state={text} />
        },
        {
            title: '编号    ',
            dataIndex: 'ddsr_id',
            width: 60,
            key: 'ddsr_id',
            
            
        }
     ];

    return (
        <div style={{marginTop:'10px'}}>
            <Flex align='center' justify='space-between'>
                <div style={{fontSize:'16px',fontWeight:'bold',color:'red'}}>收款单</div>
                {props.report_type === 'edit' ? <IncomeAddReportEdit
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    dsbzd_id={props.dsbzd_id}                                                                           
                    dsbzd_date={props.dsbzd_date}
                    dsbzd_date_end={props.dsbzd_date_end}
                    dsbzd_danhao={props.dsbzd_danhao}
                    dsbzd_name={props.dsbzd_name}
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    dsbzd_uid={props.dsbzd_uid}
                    dsbzd_state={props.dsbzd_state}
                    dsbzd_bm_id={props.dsbzd_bm_id}
                    dsbzd_bm_name={props.dsbzd_bm_name}
                    dsbzd_dscp_id={props.dsbzd_dscp_id}
                    dsbzd_dscp_name={props.dsbzd_dscp_name}
                    dsbzd_kh_id={props.dsbzd_kh_id}
                    dsbzd_kh_name={props.dsbzd_kh_name}
                /> : null}                    
            </Flex>
            <Table 
                className={classes.pinkHeader}
                dataSource={props.sr_data}
                columns={columns}
                pagination={false}
                style={{marginTop:'10px'}}
                size='small'
                rowKey="ddsr_id"                    
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);    
                    if(total>0){
                        return (
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} key="summary-0" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={1} key="summary-2" colSpan={1}></Table.Summary.Cell>
                                <Table.Summary.Cell index={2} key="summary-3" colSpan={1}>
                                <span style={{color:'red'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })}</span>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} key="summary-4" colSpan={columns.length - 2} ></Table.Summary.Cell>
                            </Table.Summary.Row>
                        );
                    }
                    return null;
                }}
                locale={{
                    emptyText: '暂无收款单' // This will display text when the table is empty
                }}
            />
        </div>
    )
}

export default IncomeListReport